export default __webpack_public_path__ + "static/media/element_spec_66.e5a188cc.jpg";